export default {
  en: {
    month: 'Month',
    '6m': '6 months',
    '12m': 'Year',
    all: 'All time',
  },
  ru: {
    month: 'Месяц',
    '6m': '6 месяцев',
    '12m': 'Год',
    all: 'Всё время',
  },
  de: {
    month: 'Monat',
    '6m': '6 Monate',
    '12m': 'Jahr',
    all: 'Gesamtzeitraum',
  },
  pt: {
    month: 'Mês',
    '6m': '6 meses',
    '12m': 'Ano',
    all: 'Todo o período',
  },
  fr: {
    month: 'Mois',
    '6m': '6 mois',
    '12m': 'An',
    all: 'Tout le temps',
  },
  es: {
    month: 'Mes',
    '6m': '6 meses',
    '12m': 'Año',
    all: 'Todo el tiempo',
  },
};
